import { ArrowRight, BedDouble, Building2, PartyPopper, ShowerHead, Sparkles, Waves } from "lucide-react";
import { Reveal } from "./Reveal";

const SERVICES = [
  {
    icon: Sparkles,
    title: "Reguler Cleaning",
    text: "Perawatan rumah rutin agar selalu nyaman ditinggali. Vakum, pel, debu hilang, suasana kembali segar — setiap kunjungan.",
    price: "Rp 60rb / jam",
    featured: true,
  },
  { icon: Waves, title: "Deep Cleaning", text: "Bersih total sampai ke sudut yang sering terlupakan. Rp 75rb / jam." },
  { icon: BedDouble, title: "Kamar & Area Tidur", text: "Bangun dengan ruang istirahat yang lebih segar dan rapi." },
  { icon: ShowerHead, title: "Dapur & Kamar Mandi", text: "Area paling sibuk di rumah, kembali higienis dan bebas kerak." },
  { icon: Building2, title: "Kantor & Ruko", text: "Ruang kerja rapi untuk produktivitas maksimal tim Anda." },
  { icon: PartyPopper, title: "Pasca Acara & Renovasi", text: "Kembalikan rumah ke kondisi terbaik setelah acara besar atau renovasi — tanpa Anda harus ikut capek.", wide: true },
];

export default function Services() {
  return (
    <section className="section" id="layanan">
      <div className="container">
        <Reveal className="section-head">
          <div>
            <span className="eyebrow">Layanan Kami</span>
            <h2 className="h2">
              Semua sudut rumah,
              <br />
              <em>kami rawat sepenuh hati.</em>
            </h2>
          </div>
          <p>Mulai dari perawatan rutin hingga pembersihan menyeluruh, kami hadir dengan standar kerja yang rapi dan konsisten.</p>
        </Reveal>
        <div className="bento">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal
                key={s.title}
                delay={i * 0.07}
                className={`bento-card ${s.featured ? "bento-feature" : ""} ${s.wide ? "bento-wide" : ""}`}
              >
                <article data-testid={`service-card-${i}`}>
                  {s.price && <span className="price-chip">{s.price}</span>}
                  <span className="icon-tile">
                    <Icon size={24} />
                  </span>
                  <h3>{s.title}</h3>
                  <p>{s.text}</p>
                  <a href="#pesan" className="card-link" data-testid={`service-booking-link-${i}`}>
                    Pesan layanan <ArrowRight size={14} />
                  </a>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
